<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Usuarios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="showDevices()">
            Dispositivos
            <v-icon right>mdi-cellphone</v-icon>
          </v-btn>
          <v-btn text small :disabled="loading || readOnly" @click="dialogNew = true">
            Agregar
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refresh()">
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading || readOnly" elevation="0" color="deep-orange" outlined class="mx-2" @click="view()">
            Editar
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading || readOnly" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogPassword = true">
            Password
            <v-icon right>mdi-lock</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading || readOnly" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogRemove = true">
            Eliminar
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
          <v-btn small :disabled="!selected.length || loading || readOnly" elevation="0" color="deep-orange" outlined class="mx-2" @click="debug()">
            Debug
            <v-icon right>mdi-bug-check</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search"
        :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
        single-select show-select class="elevation-1">
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template v-slot:item.password="{ item }">
            <v-btn v-if="item.password === ''" small rounded color="blue" dark>Disponible</v-btn>
            <v-btn v-else small rounded outlined color="blue-grey">No disponible</v-btn>
          </template>
          <template v-slot:item.perfil="{ item }">
            {{ getName(item.perfil, 'perfiles') }}
          </template>
          <template v-slot:item.empresa="{ item }">
            {{ getName(item.empresa, 'empresas') }}
          </template>
          <template v-slot:item.debug="{ item }">
            <v-icon v-if="item.debug" class="mr-2" color="success">mdi-check-circle</v-icon>
            <v-icon v-else class="mr-2" color="blue" disabled>mdi-check-circle</v-icon>
          </template>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
          <template v-slot:no-data>
            No hay información disponible
          </template>
          <template v-slot:no-results>
            No se obtuvieron resultados
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogNew" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Nuevo registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="save()">
              Guardar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formNew" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-select v-model="formNew.perfil" :items="perfiles" item-value="id" item-text="nombre" label="Perfil" :rules="formRules.perfil" :disabled="loading" required></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.username" label="Username" :rules="formRules.username" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col v-if="formNew.perfil !== 'promotor'" cols="12">
                    <v-text-field v-model="formNew.password" label="Password" :rules="formRules.password" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.email" label="Email" :rules="formRules.email" :counter="100" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.apellido_paterno" label="Apellido paterno" :rules="formRules.apellido_paterno" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.apellido_materno" label="Apellido materno" :rules="formRules.apellido_materno" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formNew.telefono" label="Teléfono" :rules="formRules.telefono" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col v-if="formNew.perfil === 'cliente'" cols="12">
                    <v-select v-model="formNew.empresa" :items="empresas" item-value="id" item-text="nombre" label="Empresa" :rules="formRules.empresa" :disabled="loading" required></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogUpdate" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="update()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formUpdate" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-select v-model="formUpdate.perfil" :items="perfiles" item-value="id" item-text="nombre" label="Perfil" :rules="formRules.perfil" :disabled="loading" required></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.username" label="Username" :rules="formRules.username" :counter="50" disabled required></v-text-field>
                  </v-col>
                  <v-col v-if="formUpdate.perfil !== 'promotor'" cols="12">
                    <v-text-field v-model="formUpdate.password" append-icon="mdi-lock" label="Password"
                    :placeholder="(formUpdate.password === '') ? '*****' : ' '" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.email" label="Email" :rules="formRules.email" :counter="100" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.nombre" label="Nombre" :rules="formRules.nombre" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.apellido_paterno" label="Apellido paterno" :rules="formRules.apellido_paterno" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.apellido_materno" label="Apellido materno" :rules="formRules.apellido_materno" :counter="150" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="formUpdate.telefono" label="Teléfono" :rules="formRules.telefono" :counter="50" :disabled="loading" required></v-text-field>
                  </v-col>
                  <v-col v-if="formUpdate.perfil === 'cliente'" cols="12">
                    <v-select v-model="formUpdate.empresa" :items="empresas" item-value="id" item-text="nombre" label="Empresa" :rules="formRules.empresa" :disabled="loading" required></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el registro?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="cancel()">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="remove()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogPassword" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar password</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updatePassword()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form ref="formPassword" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="newPassword" label="Password" :rules="(newPassword !== '') ? formRules.password : []" :counter="50"
                    :disabled="loading" required></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDevices" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Usuarios</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelDevices()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row class="pt-5" >
              <v-col>
                <v-card class="elevation-5">
                  <v-toolbar dense dark color="deep-orange" elevation="2">
                    <v-toolbar-title>Dispositivos</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-title>
                    <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="refreshDevices()">
                      Actualizar
                      <v-icon right>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn small :disabled="!devices.selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="allowDevice()">
                      Autorizar
                      <v-icon right>mdi-check-circle</v-icon>
                    </v-btn>
                    <v-btn small :disabled="!devices.selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="denyDevice()">
                      Denegar
                      <v-icon right>mdi-close-circle</v-icon>
                    </v-btn>
                    <v-btn small :disabled="!devices.selected.length || loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="dialogDevsRemove = true">
                      Eliminar
                      <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="devices.search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
                  </v-card-title>
                  <v-data-table v-model="devices.selected" :headers="devices.headers" :items="devices.items" :loading="loading" :search="devices.search"
                  :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id"
                  single-select show-select class="elevation-1">
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template v-slot:item.estatus="{ item }">
                      <v-btn v-if="item.estatus === 'activo'" small rounded color="success" dark>Autorizado</v-btn>
                      <v-btn v-else small rounded outlined color="blue-grey">No autorizado</v-btn>
                    </template>
                    <template v-slot:footer.page-text="props">
                      Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                    </template>
                    <template v-slot:no-data>
                      No hay información disponible
                    </template>
                    <template v-slot:no-results>
                      No se obtuvieron resultados
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDevsRemove" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>¿Realmente desea eliminar el dispositivo?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" color="primary" @click="dialogDevsRemove = false">
              Cancelar
            </v-btn>
            <v-btn text small :loading="loading" color="error" @click="removeDevice()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from '@/utils/services'

export default {
  name: 'usuarios',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    search: '',
    prefix: '',
    headers: [
      { text: 'Username', align: 'center', sortable: false, value: 'username' },
      { text: 'Password', align: 'center', sortable: false, value: 'password' },
      { text: 'Email', align: 'center', sortable: false, value: 'email' },
      { text: 'Nombre', align: 'center', sortable: false, value: 'nombre' },
      { text: 'Apellido paterno', align: 'center', sortable: false, value: 'apellido_paterno' },
      { text: 'Apellido materno', align: 'center', sortable: false, value: 'apellido_materno' },
      { text: 'Teléfono', align: 'center', sortable: false, value: 'telefono' },
      { text: 'Perfil', align: 'center', sortable: false, value: 'perfil' },
      { text: 'Empresa', align: 'center', sortable: false, value: 'empresa' },
      { text: 'Debug', align: 'center', sortable: false, value: 'debug' },
      { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
    ],
    items: [],
    perfiles: [
      { id: 'admin', nombre: 'Administrador'},
      { id: 'cliente', nombre: 'Cliente'},
      { id: 'promotor', nombre: 'Promotor'},
      { id: 'supervisor', nombre: 'Supervisor'},
      { id: 'gestor-dispositivos', nombre: 'Gestor Dispositivos'}
    ],
    empresas: [],
    selected: [],
    newPassword: '',
    devices: {
      search: '',
      headers: [
        { text: 'Estatus', align: 'center', sortable: false, value: 'estatus' },
        { text: 'Usuario', align: 'center', sortable: false, value: 'usuario_registro' },
        { text: 'UUID', align: 'center', sortable: false, value: 'uuid' },
        { text: 'Model', align: 'center', sortable: false, value: 'model' },
        { text: 'Fecha registro', align: 'center', sortable: false, value: 'fecha_registro' },
        { text: 'Fecha actualización', align: 'center', sortable: false, value: 'fecha_cambio' }
      ],
      items: [],
      selected: []
    },
    dialogNew: false,
    dialogUpdate: false,
    dialogPassword: false,
    dialogRemove: false,
    dialogDevices: false,
    dialogDevsRemove: false,
    formNew: {
      username: '',
      password: '',
      email: '',
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      telefono: '',
      perfil: '',
      empresa: ''
    },
    formUpdate: {
      id: '',
      username: '',
      password: '',
      email: '',
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      telefono: '',
      perfil: '',
      empresa: ''
    },
    formRules: {
      username: [
        v => !!v || 'El username es obligatorio',
        v => (v || '').length <= 50 || 'El username excede la longitud máxima'
      ],
      password: [
        v => (v || '').length <= 50 || 'El password excede la longitud máxima'
      ],
      email: [
        v => (v || '').length <= 100 || 'El email excede la longitud máxima',
        v => v === '' || /.+@.+\..+/.test(v) || 'El email es inválido'
      ],
      nombre: [
        v => (v || '').length <= 150 || 'El nombre excede la longitud máxima'
      ],
      apellido_paterno: [
        v => (v || '').length <= 150 || 'El apellido paterno excede la longitud máxima'
      ],
      apellido_materno: [
        v => (v || '').length <= 150 || 'El apellido materno excede la longitud máxima'
      ],
      telefono: [
        v => (v || '').length <= 50 || 'El teléfono excede la longitud máxima'
      ],
      perfil: [
        v => !!v || 'El perfil es obligatorio'
      ],
      empresa: [
        v => !!v || 'La empresa es obligatoria'
      ]
    }
  }),
  mounted() {
    this.check()
  },
  computed: {
    readOnly: function() {
      return (this.$store.state.general.user.role === 'gestor-dispositivos') ? true : false
    }
  },
  methods: {
    check() {
      services.ws('get', 'check')
        .then(res => {
          if (res.ok) {
            if (res.data.perfil === 'gestor-dispositivos') {
              this.prefix = 'Gestor'
            }
            this.refresh()
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
    },
    refresh() {
      this.loading = true
      services.ws('get', 'usuarios' + this.prefix)
        .then(res => {
          if (res.ok) {
            this.items = res.data.usuarios
            this.empresas = res.data.empresas
            this.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear() {
      if (this.$refs.formNew) {
        this.$refs.formNew.reset()
      }
      else if (this.$refs.formUpdate) {
        this.$refs.formUpdate.reset()
      }
      for (let key in this.formNew) {
        this.formNew[key] = ''
      }
      for (let key in this.formUpdate) {
        this.formUpdate[key] = ''
      }
    },
    cancel() {
      this.clear()
      this.selected = []
      this.newPassword = ''
      this.dialogNew = false
      this.dialogUpdate = false
      this.dialogPassword = false
      this.dialogRemove = false
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'nuevoUsuario', this.formNew)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    view() {
      this.formUpdate = JSON.parse(JSON.stringify(this.selected[0]))
      this.dialogUpdate = true
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true
        setTimeout(() => {
          services.ws('post', 'actualizarUsuario', this.formUpdate)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    remove() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'eliminarUsuario', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    debug() {
      this.loading = true
      setTimeout(() => {
        let id = this.selected[0].id
        services.ws('post', 'actualizarModoDebugUsuario', { id })
          .then(res => {
            if (res.ok) {
              this.cancel()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    getName(id, key) {
      for (let i = 0; i < this[key].length; i++) {
        if (this[key][i].id == id) {
          return this[key][i].nombre
        }
      }
      return null
    },
    updatePassword() {
      if (this.$refs.formPassword.validate()) {
        this.loading = true
        let data = {
          id: this.selected[0].id,
          password: this.newPassword
        }
        setTimeout(() => {
          services.ws('post', 'actualizarPassword', data)
            .then(res => {
              if (res.ok) {
                this.cancel()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }, 800)
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos son inválidos'
      }
    },
    showDevices() {
      this.loading = true
      services.ws('get', 'dispositivos' + this.prefix)
        .then(res => {
          if (res.ok) {
            this.devices.items = res.data.dispositivos
            this.dialogDevices = true
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false 
        })
    },
    refreshDevices() {
      this.loading = true
      services.ws('get', 'dispositivos' + this.prefix)
        .then(res => {
          if (res.ok) {
            this.devices.items = res.data.dispositivos
            this.devices.selected = []
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false 
        })
    },
    clearInfoDevices() {
      this.devices.search = ''
      this.devices.items = []
      this.devices.selected = []
      this.dialogDevsRemove = false
    },
    cancelDevices() {
      this.clearInfoDevices()
      this.dialogDevices = false
    },
    allowDevice() {
      this.loading = true
      setTimeout(() => {
        let id = this.devices.selected[0].id
        services.ws('post', 'autorizarDispositivo' + this.prefix, { id })
          .then(res => {
            if (res.ok) {
              this.clearInfoDevices()
              this.refreshDevices()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    denyDevice() {
      this.loading = true
      setTimeout(() => {
        let id = this.devices.selected[0].id
        services.ws('post', 'denegarDispositivo' + this.prefix, { id })
          .then(res => {
            if (res.ok) {
              this.clearInfoDevices()
              this.refreshDevices()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    },
    removeDevice() {
      this.loading = true
      setTimeout(() => {
        let id = this.devices.selected[0].id
        services.ws('post', 'eliminarDispositivo' + this.prefix, { id })
          .then(res => {
            if (res.ok) {
              this.clearInfoDevices()
              this.refreshDevices()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 800)
    }
  }
}
</script>
